'use client';

import {
  consumeShopFocusIntent,
  SHOP_FOCUS_FILTER_BAR,
} from '@/features/shop/shopFocusIntent';
import { useEffect } from 'react';

export default function ShopFocusRestore({
  resultsTargetId = 'home-screen-products',
  resultsFocusId = '',
}) {
  useEffect(() => {
    const intent = consumeShopFocusIntent();

    if (!intent) {
      return;
    }

    const targetId =
      intent === SHOP_FOCUS_FILTER_BAR
        ? resultsFocusId || 'filter-bar'
        : resultsTargetId;
    const targetElement = document.getElementById(targetId);
    const focusElement = targetElement;

    if (!targetElement || !focusElement) {
      return;
    }

    if (!focusElement.hasAttribute('tabindex')) {
      focusElement.setAttribute('tabindex', '-1');
    }

    const restoreFocus = () => {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });

      focusElement.focus({ preventScroll: true });
    };

    const timeoutId = window.setTimeout(restoreFocus, 120);
    let deferredTimeoutId = 0;

    const shouldWaitForHero =
      intent === SHOP_FOCUS_FILTER_BAR && targetId === resultsFocusId;

    const handleHeroReady = () => {
      window.clearTimeout(deferredTimeoutId);
      deferredTimeoutId = window.setTimeout(restoreFocus, 40);
    };

    if (shouldWaitForHero) {
      window.addEventListener('topproducts:ready', handleHeroReady, {
        once: true,
      });
      deferredTimeoutId = window.setTimeout(restoreFocus, 700);
    }

    return () => {
      window.clearTimeout(timeoutId);
      window.clearTimeout(deferredTimeoutId);
      window.removeEventListener('topproducts:ready', handleHeroReady);
    };
  }, [resultsFocusId, resultsTargetId]);

  return null;
}
